<template>
  <div class="completed-wrapper">
    <!--  FoodB_0526_CJIS_cGuT: 店铺配送 -->
    <mobile-header :title="$t('FoodB_0526_CJIS_cGuT')" />
    <div class="completed-page">
      <div class="header">
        <progress-steps
          :steps="[
            $t('FoodB_0526_obJO_XULq', {number1: 1}), // FoodB_0526_obJO_XULq 步骤{{number1}}
            $t('FoodB_0526_BiXD_Hdyk', {number2: 2})  // FoodB_0526_BiXD_Hdyk 步骤{{number2}}
          ]"
          :current-step="2"
        />
      </div>
      <div class="content">
        <div class="success-icon">
          <img src="@/assets/images/delivery-rider.png" alt="success" />
        </div>
        <!-- FoodB_0526_RjfK_pdye： 感谢您的配送，订单已经确认送达。 -->
        <div class="success-text">{{ $t('FoodB_0526_RjfK_pdye') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressSteps from '@/components/progress-steps' 
import Track from '@/utils/track'
import MobileHeader from '@/components/mobile-header'

export default {
  name: 'CompletedPage',
  components: {
    ProgressSteps,
    MobileHeader
  },
  mounted() {
    const { shopId, orderId } = this.$route.query
    Track.deliveredShow({
      shop_id: shopId,
      order_id: orderId,
    })
  },
}
</script>

<style lang="scss" scoped>
.completed-page {
  max-width: 750px;
  margin: 0 auto;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  padding: 40px;

  .header {
    padding: 16px;
    background: #FFFFFF;
    .title {
      font-size: 20px;
      font-weight: 600;
      color: #333333;
      text-align: center;
      margin-bottom: 24px;
    }
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;    
    justify-content: center;
    padding: 32px;
    background: #FFFFFF;

    .success-icon {
      img {
        width: 280px;
        object-fit: contain;
        margin-top: 64px;
        margin-bottom: 96px;
      }
    }

    .success-text {
      font-family: DiDiSans-Pro-Bold;
      font-size: 48px;
      color: #0B0B0D;
      letter-spacing: 0;
      text-align: center;
      line-height: 56px;
      font-weight: 700;
      margin-bottom: 100px;
    }
  }
  .footer {
    padding: 16px;
    background: #FFFFFF;
  }
}
</style>